import { z } from 'zod'

export const TranslationSchema = z.object({
	id: z.string(),
	locale: z.string(),
	countryCode: z.string(),
	messages: z.record(z.any()),
	enabled: z.boolean(),
	storeId: z.string(),
	accountId: z.string().nullable().optional(),
	createdAt: z.date().optional(),
	updatedAt: z.date().optional(),
})

export type TranslationType = z.infer<typeof TranslationSchema>

export const toTranslationDto = (data: any): TranslationType => {
	return TranslationSchema.parse({
		...data,
		messages: data.messages ?? {},
		enabled: data.enabled ?? true,
	})
}

